import React from "react";

interface Props {}

const Home: React.FC<Props> = () => {
	window.location.href = "/login";
	return <></>;
};

export default Home;
